import React from 'react';
import { TrendingUp, TrendingDown, Wallet, Hash } from 'lucide-react';

interface SummaryBarProps {
  totalEntradas: number;
  totalSaidas: number;
  saldoAtual: number;
  totalTransacoes: number;
  formatCurrency: (v: number) => string;
}

export default function SummaryBar({
  totalEntradas,
  totalSaidas,
  saldoAtual,
  totalTransacoes,
  formatCurrency,
}: SummaryBarProps) {
  const saldoPositive = saldoAtual >= 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {/* Total Entradas */}
      <div className="bg-card rounded-lg border border-border shadow-card px-4 py-3 flex items-center gap-3">
        <div className="flex-shrink-0 w-9 h-9 rounded-md bg-entrada-soft flex items-center justify-center">
          <TrendingUp size={18} className="text-entrada" />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-medium text-muted-foreground tracking-wide uppercase">
            Total Entradas
          </p>
          <p className="text-base font-semibold text-entrada font-mono-nums truncate">
            {formatCurrency(totalEntradas)}
          </p>
        </div>
      </div>

      {/* Total Saídas */}
      <div className="bg-card rounded-lg border border-border shadow-card px-4 py-3 flex items-center gap-3">
        <div className="flex-shrink-0 w-9 h-9 rounded-md bg-saida-soft flex items-center justify-center">
          <TrendingDown size={18} className="text-saida" />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-medium text-muted-foreground tracking-wide uppercase">
            Total Saídas
          </p>
          <p className="text-base font-semibold text-saida font-mono-nums truncate">
            {formatCurrency(totalSaidas)}
          </p>
        </div>
      </div>

      {/* Saldo Atual */}
      <div
        className={`bg-card rounded-lg border shadow-card px-4 py-3 flex items-center gap-3 ${
          saldoPositive ? 'border-success/30' : 'border-danger/30'
        }`}
      >
        <div
          className={`flex-shrink-0 w-9 h-9 rounded-md flex items-center justify-center ${
            saldoPositive ? 'bg-entrada-soft' : 'bg-saida-soft'
          }`}
        >
          <Wallet
            size={18}
            className={saldoPositive ? 'text-entrada' : 'text-saida'}
          />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-medium text-muted-foreground tracking-wide uppercase">
            Saldo Atual
          </p>
          <p
            className={`text-base font-bold font-mono-nums truncate ${
              saldoPositive ? 'text-saldo-positive' : 'text-saldo-negative'
            }`}
          >
            {formatCurrency(saldoAtual)}
          </p>
        </div>
      </div>

      {/* Total de Lançamentos */}
      <div className="bg-card rounded-lg border border-border shadow-card px-4 py-3 flex items-center gap-3">
        <div className="flex-shrink-0 w-9 h-9 rounded-md bg-secondary flex items-center justify-center">
          <Hash size={18} className="text-primary" />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-medium text-muted-foreground tracking-wide uppercase">
            Lançamentos
          </p>
          <p className="text-base font-semibold text-foreground font-mono-nums">
            {totalTransacoes}
          </p>
        </div>
      </div>
    </div>
  );
}